import '@spartacus/storefront';
import { LAUNCH_CALLER, LaunchDialog } from '@spartacus/storefront';

export interface DialogOptions {
  onTop?: boolean;
  fixedHeight?: boolean;
  autoDismissOnRouteChange?: boolean;
  autoDismissOnLogout?: boolean;
}

declare module '@spartacus/storefront' {
  enum LAUNCH_CALLER {
    ADDRESS_EDITOR = 'ADDRESS_EDITOR',
    CREATE_SHOPPING_LIST = 'CREATE_SHOPPING_LIST',
    DELETE_SHOPPING_LIST = 'DELETE_SHOPPING_LIST',
    EXPORT_SHOPPING_LIST = 'EXPORT_SHOPPING_LIST',
    REMOVE_SHOPPING_LIST_ENTRIES = 'REMOVE_SHOPPING_LIST_ENTRIES',
    CONNECT_ALL = 'CONNECT_ALL',
    REMOVE_PRINCIPALS = 'REMOVE_PRINCIPALS',
    CHANGE_CONTACT_PERSON = 'CHANGE_CONTACT_PERSON',
    EMPTY_CART = 'EMPTY_CART',
    ORDER_ENTRY_ACCOUNTING_CODES = 'ORDER_ENTRY_ACCOUNTING_CODES',
    IMAGE = 'IMAGE',
    SAMPLE_ORDER = 'SAMPLE_ORDER',
    AREA_OF_USE_ADMIN_OVERVIEW_HELP = 'AREA_OF_USE_ADMIN_OVERVIEW_HELP',
    AREA_OF_USE_ADMIN_IMPORT = 'AREA_OF_USE_ADMIN_IMPORT',
    AREA_OF_USE_REMOVE_PRODUCTS = 'AREA_OF_USE_REMOVE_PRODUCTS',
    PDP_INQUIRY = 'PDP_INQUIRY',
    USERS_IMPORT_INFO = 'USERS_IMPORT_INFO',
    USER_DETAILS_DELETE_CONFIRMATION = 'USER_DETAILS_DELETE_CONFIRMATION',
    USER_DETAILS_DEACTIVATE_CONFIRMATION = 'USER_DETAILS_DEACTIVATE_CONFIRMATION',
    USER_DETAILS_REJECT_CONFIRMATION = 'USER_DETAILS_REJECT_CONFIRMATION',
    USER_DETAILS_EDIT_USER_INFORMATION = 'USER_DETAILS_EDIT_USER_INFORMATION',
    PDP_LIST_VARIANTS = 'PDP_LIST_VARIANTS',
    REMOVE_ACCOUNT = 'REMOVE_ACCOUNT',
    PRICE_FILE_REQUEST_TEMPLATE_SAVER = 'PRICE_FILE_REQUEST_TEMPLATE_SAVER',
    ORDER_CARD_DELETE = 'ORDER_CARD_DELETE',
    ORDER_CARD_UPDATE_STATUS = 'ORDER_CARD_UPDATE_STATUS',
    ORDER_CARD_DELETE_USER = 'ORDER_CARD_DELETE_USER',
    ORDER_CARD_DELETE_USERS = 'ORDER_CARD_DELETE_USERS',
    ORDER_CARD_DELETE_PRODUCTS = 'ORDER_CARD_DELETE_PRODUCTS',
    ORDER_CARD_PRODUCT_LIST = 'ORDER_CARD_PRODUCT_LIST',
    ORDER_CARD_SKU_PICKER = 'ORDER_CARD_SKU_PICKER',
    PALLET_FLAG_FORM = 'PALLET_FLAG_FORM',
    CUTTING = 'CUTTING',
    REEL_CUTTING = 'REEL_CUTTING',
    PRE_PRINTED = 'PRE_PRINTED',
    ACCOUNTING_CODE_DELETE_CONFIRMATION = 'ACCOUNTING_CODE_DELETE_CONFIRMATION',
    NAME_MARKING = 'NAME_MARKING',
    PUBLISH_PURCHASE_LIMIT = 'PUBLISH_PURCHASE_LIMIT',
    UNPUBLISH_PURCHASE_LIMIT = 'UNPUBLISH_PURCHASE_LIMIT',
    DELETE_PURCHASE_LIMIT = 'DELETE_PURCHASE_LIMIT',
    PERMISSION_TYPE = 'PERMISSION_TYPE',
    NO_MORE_CONNECTIONS_WARNING = 'NO_MORE_CONNECTIONS_WARNING',
    ORDER_APPROVAL_ABORT_HIJACK = 'ORDER_APPROVAL_ABORT_HIJACK',
    ORDER_APPROVAL_COMMENT = 'ORDER_APPROVAL_COMMENT',
    ORDER_APPROVAL_DELETE_CONFIRMATION = 'ORDER_APPROVAL_DELETE_CONFIRMATION',
    MY_ASSORTMENT_NEW_FREE_ARTICLE = 'MY_ASSORTMENT_NEW_FREE_ARTICLE',
    EXCLUDE_ARTICLES = 'EXCLUDE_ARTICLES',
    FIND_MY_COMPANY_INFORMATION = 'FIND_MY_COMPANY_INFORMATION',
    CONFIRM_EMAIL = 'CONFIRM_EMAIL',
    CANCEL_ORDER_RETURN_DRAFT = 'CANCEL_ORDER_RETURN_DRAFT',
    LEGAL = 'LEGAL',
    LEGAL_DISMISSABLE_ON_LOGOUT = 'LEGAL_DISMISSABLE_ON_LOGOUT',
    ORDER_RETURN_UPLOADED_FILES_GALLERY = 'ORDER_RETURN_UPLOADED_FILES_GALLERY',
    CHECKOUT_PAYMENT = 'CHECKOUT_PAYMENT',
    ACTIVE_ORDER_PROCESS = 'ACTIVE_ORDER_PROCESS',
    RELOAD_MODAL_BODY = 'RELOAD_MODAL_BODY',
    ORDER_MERGE_PROPOSALS = 'ORDER_MERGE_PROPOSALS',
    SEARCH_SCORE = 'SEARCH_SCORE',
    SOLD_TO_SELECTOR = 'SOLD_TO_SELECTOR',
  }

  interface LaunchDialog {
    dialogOptions?: DialogOptions;
  }
}

(LAUNCH_CALLER as any)['ADDRESS_EDITOR'] = 'ADDRESS_EDITOR';
(LAUNCH_CALLER as any)['CREATE_SHOPPING_LIST'] = 'CREATE_SHOPPING_LIST';
(LAUNCH_CALLER as any)['DELETE_SHOPPING_LIST'] = 'DELETE_SHOPPING_LIST';
(LAUNCH_CALLER as any)['EXPORT_SHOPPING_LIST'] = 'EXPORT_SHOPPING_LIST';
(LAUNCH_CALLER as any)['REMOVE_SHOPPING_LIST_ENTRIES'] = 'REMOVE_SHOPPING_LIST_ENTRIES';
(LAUNCH_CALLER as any)['CONNECT_ALL'] = 'CONNECT_ALL';
(LAUNCH_CALLER as any)['REMOVE_PRINCIPALS'] = 'REMOVE_PRINCIPALS';
(LAUNCH_CALLER as any)['CHANGE_CONTACT_PERSON'] = 'CHANGE_CONTACT_PERSON';
(LAUNCH_CALLER as any)['EMPTY_CART'] = 'EMPTY_CART';
(LAUNCH_CALLER as any)['ORDER_ENTRY_ACCOUNTING_CODES'] = 'ORDER_ENTRY_ACCOUNTING_CODES';
(LAUNCH_CALLER as any)['IMAGE'] = 'IMAGE';
(LAUNCH_CALLER as any)['SAMPLE_ORDER'] = 'SAMPLE_ORDER';
(LAUNCH_CALLER as any)['AREA_OF_USE_ADMIN_OVERVIEW_HELP'] = 'AREA_OF_USE_ADMIN_OVERVIEW_HELP';
(LAUNCH_CALLER as any)['AREA_OF_USE_ADMIN_IMPORT'] = 'AREA_OF_USE_ADMIN_IMPORT';
(LAUNCH_CALLER as any)['AREA_OF_USE_REMOVE_PRODUCTS'] = 'AREA_OF_USE_REMOVE_PRODUCTS';
(LAUNCH_CALLER as any)['PDP_INQUIRY'] = 'PDP_INQUIRY';
(LAUNCH_CALLER as any)['USERS_IMPORT_INFO'] = 'USERS_IMPORT_INFO';
(LAUNCH_CALLER as any)['USER_DETAILS_DELETE_CONFIRMATION'] = 'USER_DETAILS_DELETE_CONFIRMATION';
(LAUNCH_CALLER as any)['USER_DETAILS_DEACTIVATE_CONFIRMATION'] = 'USER_DETAILS_DEACTIVATE_CONFIRMATION';
(LAUNCH_CALLER as any)['USER_DETAILS_REJECT_CONFIRMATION'] = 'USER_DETAILS_REJECT_CONFIRMATION';
(LAUNCH_CALLER as any)['USER_DETAILS_EDIT_USER_INFORMATION'] = 'USER_DETAILS_EDIT_USER_INFORMATION';
(LAUNCH_CALLER as any)['PDP_LIST_VARIANTS'] = 'PDP_LIST_VARIANTS';
(LAUNCH_CALLER as any)['REMOVE_ACCOUNT'] = 'REMOVE_ACCOUNT';
(LAUNCH_CALLER as any)['PRICE_FILE_REQUEST_TEMPLATE_SAVER'] = 'PRICE_FILE_REQUEST_TEMPLATE_SAVER';
(LAUNCH_CALLER as any)['ORDER_CARD_DELETE'] = 'ORDER_CARD_DELETE';
(LAUNCH_CALLER as any)['ORDER_CARD_UPDATE_STATUS'] = 'ORDER_CARD_UPDATE_STATUS';
(LAUNCH_CALLER as any)['ORDER_CARD_DELETE_USER'] = 'ORDER_CARD_DELETE_USER';
(LAUNCH_CALLER as any)['ORDER_CARD_DELETE_USERS'] = 'ORDER_CARD_DELETE_USERS';
(LAUNCH_CALLER as any)['ORDER_CARD_DELETE_PRODUCTS'] = 'ORDER_CARD_DELETE_PRODUCTS';
(LAUNCH_CALLER as any)['ORDER_CARD_PRODUCT_LIST'] = 'ORDER_CARD_PRODUCT_LIST';
(LAUNCH_CALLER as any)['ORDER_CARD_SKU_PICKER'] = 'ORDER_CARD_SKU_PICKER';
(LAUNCH_CALLER as any)['PALLET_FLAG_FORM'] = 'PALLET_FLAG_FORM';
(LAUNCH_CALLER as any)['CUTTING'] = 'CUTTING';
(LAUNCH_CALLER as any)['REEL_CUTTING'] = 'REEL_CUTTING';
(LAUNCH_CALLER as any)['PRE_PRINTED'] = 'PRE_PRINTED';
(LAUNCH_CALLER as any)['ACCOUNTING_CODE_DELETE_CONFIRMATION'] = 'ACCOUNTING_CODE_DELETE_CONFIRMATION';
(LAUNCH_CALLER as any)['NAME_MARKING'] = 'NAME_MARKING';
(LAUNCH_CALLER as any)['PUBLISH_PURCHASE_LIMIT'] = 'PUBLISH_PURCHASE_LIMIT';
(LAUNCH_CALLER as any)['UNPUBLISH_PURCHASE_LIMIT'] = 'UNPUBLISH_PURCHASE_LIMIT';
(LAUNCH_CALLER as any)['DELETE_PURCHASE_LIMIT'] = 'DELETE_PURCHASE_LIMIT';
(LAUNCH_CALLER as any)['PERMISSION_TYPE'] = 'PERMISSION_TYPE';
(LAUNCH_CALLER as any)['NO_MORE_CONNECTIONS_WARNING'] = 'NO_MORE_CONNECTIONS_WARNING';
(LAUNCH_CALLER as any)['ORDER_APPROVAL_ABORT_HIJACK'] = 'ORDER_APPROVAL_ABORT_HIJACK';
(LAUNCH_CALLER as any)['ORDER_APPROVAL_COMMENT'] = 'ORDER_APPROVAL_COMMENT';
(LAUNCH_CALLER as any)['ORDER_APPROVAL_DELETE_CONFIRMATION'] = 'ORDER_APPROVAL_DELETE_CONFIRMATION';
(LAUNCH_CALLER as any)['MY_ASSORTMENT_NEW_FREE_ARTICLE'] = 'MY_ASSORTMENT_NEW_FREE_ARTICLE';
(LAUNCH_CALLER as any)['EXCLUDE_ARTICLES'] = 'EXCLUDE_ARTICLES';
(LAUNCH_CALLER as any)['FIND_MY_COMPANY_INFORMATION'] = 'FIND_MY_COMPANY_INFORMATION';
(LAUNCH_CALLER as any)['CONFIRM_EMAIL'] = 'CONFIRM_EMAIL';
(LAUNCH_CALLER as any)['CANCEL_ORDER_RETURN_DRAFT'] = 'CANCEL_ORDER_RETURN_DRAFT';
(LAUNCH_CALLER as any)['LEGAL'] = 'LEGAL';
(LAUNCH_CALLER as any)['LEGAL_DISMISSABLE_ON_LOGOUT'] = 'LEGAL_DISMISSABLE_ON_LOGOUT';
(LAUNCH_CALLER as any)['ORDER_RETURN_UPLOADED_FILES_GALLERY'] = 'ORDER_RETURN_UPLOADED_FILES_GALLERY';
(LAUNCH_CALLER as any)['CHECKOUT_PAYMENT'] = 'CHECKOUT_PAYMENT';
(LAUNCH_CALLER as any)['ACTIVE_ORDER_PROCESS'] = 'ACTIVE_ORDER_PROCESS';
(LAUNCH_CALLER as any)['RELOAD_MODAL_BODY'] = 'RELOAD_MODAL_BODY';
(LAUNCH_CALLER as any)['ORDER_MERGE_PROPOSALS'] = 'ORDER_MERGE_PROPOSALS';
(LAUNCH_CALLER as any)['SEARCH_SCORE'] = 'SEARCH_SCORE';
(LAUNCH_CALLER as any)['SOLD_TO_SELECTOR'] = 'SOLD_TO_SELECTOR';

export { LAUNCH_CALLER, LaunchDialog };
